import { useRef } from "react"
import { Stack } from "@mui/material";
import CustomAreaChart from "../../../components/charts/CustomAreaChart";
import { singleAxisFormatter } from "../../../utils/chart";
import ChartRangeToggleGroup from "../../../components/charts/ChartRangeToggleGroup";
import DataPointDelta from "../../../components/DataPointDelta";
import { capitalizeEachFirstLetterFormatter } from "../../../utils/formatters";

const HistoricChart = ({ plottingHistoricPoints, instrumentId, instrumentName, plottingRange, handlePlottingRangeChangeHandler, chartRangeToggleOptions, plottingType, handlePlottingTypeChangeHandler, chartTypeToggleOptions }) => {

    const formattedPlottingData = singleAxisFormatter(plottingType, plottingHistoricPoints, instrumentId, instrumentName)
    const charLabel = capitalizeEachFirstLetterFormatter(plottingType)
    const currentValue = formattedPlottingData.data.at(-1).y
    const referenceValue = formattedPlottingData.data.at(0).y
    const chartRef = useRef(null);

    return (
        <Stack gap={2} sx={{ flex: 1 }}>
            <Stack direction={{ xs: "column", sm: "row" }} gap={{ xs: 4 }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent={{ xs: "flex-start", sm: "space-between" }} >
                {
                    chartRangeToggleOptions.length && plottingType !== "" && formattedPlottingData &&
                    <DataPointDelta
                        label={charLabel}
                        currentValue={currentValue}
                        referenceValue={referenceValue}
                        referenceTimeRange={chartRangeToggleOptions.filter(option => option.value === plottingRange)[0].label}
                    />
                }
                <ChartRangeToggleGroup
                    value={plottingType}
                    changeHandler={handlePlottingTypeChangeHandler}
                    options={chartTypeToggleOptions}
                />
            </Stack>
            <Stack gap={4} alignItems="center">
                <CustomAreaChart chartData={formattedPlottingData} chartRef={chartRef} />
                <ChartRangeToggleGroup
                    value={plottingRange}
                    changeHandler={handlePlottingRangeChangeHandler}
                    options={chartRangeToggleOptions}
                />
            </Stack>
        </Stack>
    );
};

export default HistoricChart;